/**
 * 企业目录 接口
 *
 *  author： 张艳迎
 *  date： 2023-11-21 13:55:05
 */


import request from '@/plugins/request';

/**
 * 企业目录列表
 * @param query
 */
export function listEnterpriseDirectory (query) {
    return request({
        url: '/economy/enterprise-directory/list',
        method: 'get',
        params: query
    })
}


/**
 * 企业目录分页
 * @param query
 */
export function pageEnterpriseDirectory (query) {
    return request({
        url: '/economy/enterprise-directory/page',
        method: 'get',
        params: query
    })
}

/**
 * 根据id删除企业目录
 * @param id
 */
export function delEnterpriseDirectory (id) {
    return request({
        url: '/economy/enterprise-directory/' + id,
        method: 'delete'
    })
}
/**
 * 添加企业目录
 * @param obj
 */
export function addEnterpriseDirectory(obj) {
    return request({
        url: '/economy/enterprise-directory',
        method: 'post',
        data: obj
    })
}
/**
 * 部门树
 * @param query
 */
export function treeEnterpriseDirectory (query) {
    return request({
        url: '/economy/enterprise-directory/tree',
        method: 'get',
        params: query
    })
}

/**
 * 合同部门树
 * @param query
 */
export function treeEnterpriseDirectoryByContract (query) {
    return request({
        url: '/economy/enterprise-directory/contractTree',
        method: 'get',
        params: query
    })
}



/**
 * 修改企业目录
 * @param obj
 */
export function updateEnterpriseDirectory (obj) {
    return request({
        url: '/economy/enterprise-directory',
        method: 'put',
        data: obj
    })
}


/**
 * 根据id查询企业目录
 * @param id
 */
export function getEnterpriseDirectory (id) {
    return request({
        url: '/economy/enterprise-directory/get-by-id/' + id,
        method: 'get'
    })
}



